import React, { useMemo, useState } from "react";
import { ADMINISTRATIONS } from "@/data/studentData";
import LogoTile from "@/components/LogoTile";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function Administrations() {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("Tous");
  const cats = useMemo(() => ["Tous", ...Array.from(new Set(ADMINISTRATIONS.map((a) => a.category)))], []);
  const filtered = useMemo(() => {
    const qq = q.trim().toLowerCase();
    return ADMINISTRATIONS.filter((a) => {
      if (cat !== "Tous" && a.category !== cat) return false;
      if (!qq) return true;
      return a.name.toLowerCase().includes(qq) || a.tagline.toLowerCase().includes(qq);
    });
  }, [q, cat]);

  return (
    <div className="space-y-8" data-testid="admins-page">
      <header>
        <p className="text-xs uppercase tracking-[0.2em] text-indigo-500 font-semibold">Accès direct</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 mt-2">Administrations françaises</h1>
        <p className="text-slate-600 mt-2 max-w-2xl">
          Tous les liens officiels en un clic : aides, santé, impôts, transports, papiers. Clique pour ouvrir le site officiel.
        </p>
      </header>

      <div className="flex flex-col sm:flex-row gap-3 sm:items-center">
        <div className="relative flex-1 max-w-md">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Rechercher (CAF, Ameli, SNCF...)"
            className="pl-9"
            data-testid="admin-search-input"
          />
        </div>
        <div className="flex gap-2 flex-wrap">
          {cats.map((c) => (
            <button
              key={c}
              onClick={() => setCat(c)}
              data-testid={`admin-cat-${c}`}
              className={`px-3.5 py-1.5 rounded-full text-sm border transition-colors ${
                cat === c
                  ? "bg-slate-900 text-white border-slate-900"
                  : "bg-white text-slate-600 border-slate-200 hover:border-slate-300"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {filtered.map((a) => <LogoTile key={a.id} item={a} />)}
      </div>
      {filtered.length === 0 && (
        <p className="text-slate-500 text-center py-10">Aucun résultat.</p>
      )}
    </div>
  );
}
